import { useState } from "react";
import EntryCard from "../EntryCard/EntryCard.jsx";
import styles from "./EntryGrid.module.css";

/** Grid of EntryCards with client-side "Show more". All items are in the prerendered data. */
export default function EntryGrid({
  items,
  kind,
  hrefFor,
  metaFor,
  descriptionFor,
  pageSize = 12,
  emptyText = "Nothing here yet.",
}) {
  const [limit, setLimit] = useState(pageSize);
  if (!items.length) return <p>{emptyText}</p>;
  const shown = items.slice(0, limit);
  return (
    <>
      <div className="grid grid-3">
        {shown.map((item) => (
          <EntryCard
            key={item.slug}
            kind={kind}
            href={hrefFor(item)}
            image={item.image}
            imageAlt={item.imageAlt}
            title={item.title}
            description={descriptionFor ? descriptionFor(item) : item.description}
            meta={metaFor ? metaFor(item) : item.date}
          />
        ))}
      </div>
      {items.length > limit ? (
        <p className={styles.more}>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setLimit(limit + pageSize)}
          >
            Show more ({items.length - limit} more)
          </button>
        </p>
      ) : null}
    </>
  );
}
